export const EN = 'en-US'
export const RO = 'ro'
export const DEFAULT_LOCALE = EN
export const LOCALES = [EN, RO]
